<div class="flex flex-col h-full bg-white">
  <div class="h-[72px] bg-white border-b border-gray-200 flex items-center justify-between px-4">
    @if (hasCompletedChats()) {
      <lucide-angular
        name="chevron-left"
        class="cursor-pointer text-[#212e4a]"
        [size]="24"
        (click)="onBackClick()"
      ></lucide-angular>
    } @else {
      <div class="w-6"></div>
    }

    <div></div>

    <lucide-angular
      name="x"
      class="cursor-pointer text-[#212e4a]"
      [size]="24"
      (click)="onCloseClick()"
    ></lucide-angular>
  </div>

  <div class="flex-1 overflow-y-auto px-4 py-6">
    <h2 class="text-center text-[#212e4a] text-lg font-medium mb-6">Which pet would you like to speak to us about?</h2>

    <div class="space-y-3">
      @for (pet of pets(); track pet.doc_id) {
        <button
          type="button"
          class="w-full flex items-center gap-4 p-4 rounded-lg border-2 transition-all duration-200"
          [class.border-[#212e4a]]="selectedPet()?.doc_id === pet.doc_id"
          [class.bg-[#f8f9fa]]="selectedPet()?.doc_id === pet.doc_id"
          [class.border-gray-200]="selectedPet()?.doc_id !== pet.doc_id"
          [class.bg-white]="selectedPet()?.doc_id !== pet.doc_id"
          (click)="selectPet(pet)"
        >
          <div class="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-100">
            @if (pet.photo_url) {
              <img [src]="pet.photo_url" [alt]="pet.name" class="w-full h-full object-cover" />
            } @else {
              <div class="w-full h-full flex items-center justify-center">
                @if (pet.species === 'Dog') {
                  <lucide-angular name="dog" class="text-[#207EA7]" [size]="24"></lucide-angular>
                } @else {
                  <lucide-angular name="cat" class="text-[#B15420]" [size]="24"></lucide-angular>
                }
              </div>
            }
          </div>

          <span class="flex-1 text-left text-[#212e4a] font-medium">{{ pet.name }}</span>

          <div
            class="w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0"
            [class.border-[#212e4a]]="selectedPet()?.doc_id === pet.doc_id"
            [class.bg-[#212e4a]]="selectedPet()?.doc_id === pet.doc_id"
            [class.border-gray-300]="selectedPet()?.doc_id !== pet.doc_id"
          >
            @if (selectedPet()?.doc_id === pet.doc_id) {
              <lucide-angular name="check" class="text-white" [size]="14"></lucide-angular>
            }
          </div>
        </button>
      }
    </div>
  </div>

  <div class="p-4 border-t border-gray-200">
    <button
      type="button"
      class="w-full py-3 px-4 rounded-lg font-medium transition-all duration-200"
      [class.bg-[#212e4a]]="selectedPet()"
      [class.text-white]="selectedPet()"
      [class.cursor-pointer]="selectedPet()"
      [class.bg-gray-200]="!selectedPet()"
      [class.text-gray-400]="!selectedPet()"
      [class.cursor-not-allowed]="!selectedPet()"
      [disabled]="!selectedPet()"
      (click)="confirmSelection()"
    >
      Select pet
    </button>
  </div>
</div>
